// SectionHeader.jsx
const SectionHeader = ({
  icon,
  title,
  extra,
  className = "",
  withBorder = false, // set true if you want that faint line below
}) => {
  return (
    <div
      className={`
        flex items-center justify-between
        py-2
        mt-1
        ${withBorder ? "border-b border-gray-100" : ""}
        ${className}
      `}
    >
      {/* LEFT: icon + title */}
      <div className="flex items-center gap-2 min-w-0">
        {icon && (
          <span className="text-lg flex-shrink-0 flex items-center">
            {icon}
          </span>
        )}
        <h2 className="text-[16px] font-semibold text-slate-900 truncate">
          {title}
        </h2>
      </div>

      {/* RIGHT: extra */}
      {extra && <div className="flex items-center flex-shrink-0">{extra}</div>}
    </div>
  );
};

export default SectionHeader;
